import clsx from 'clsx';
import React, { ComponentRef, forwardRef } from 'react';
import classNames from './View.module.css';
import { ViewProps } from './props';
import { useStyles } from './useViewStyles';

export const View = forwardRef<HTMLDivElement, ViewProps>(function View(props, ref) {
  const {
    children,
    style,
    className,
    row,
    wrap,
    shrinkWrap,
    fill,
    flex,
    fullWidth,
    fullHeight,
    relative,
    absolute,
    center,
    centerVertically,
    centerHorizontally,
    gap,
    margin,
    marginTop,
    marginLeft,
    marginRight,
    marginBottom,
    marginVertical,
    marginHorizontal,
    padding,
    paddingTop,
    paddingLeft,
    paddingRight,
    paddingBottom,
    paddingVertical,
    paddingHorizontal,
    vars,
    testID,
    ...otherProps
  } = props;
  const styles = useStyles({
    gap,
    margin,
    marginTop,
    marginLeft,
    marginRight,
    marginBottom,
    marginVertical,
    marginHorizontal,
    padding,
    paddingTop,
    paddingLeft,
    paddingRight,
    paddingBottom,
    paddingVertical,
    paddingHorizontal,
    flex,
    vars,
    style,
  });

  return (
    <div
      ref={ref}
      style={styles}
      className={clsx(
        classNames.view,
        {
          [classNames.row]: row,
          [classNames.rowReverse]: row === 'reverse',
          [classNames.column]: !row,
          [classNames.wrap]: wrap,
          [classNames.shrinkWrap]: shrinkWrap,
          [classNames.center]: center,
          [classNames.centerVertically]: centerVertically,
          [classNames.centerHorizontally]: centerHorizontally,
          [classNames.fill]: fill,
          [classNames.fullWidth]: fullWidth,
          [classNames.fullHeight]: fullHeight,
          [classNames.relative]: relative,
          [classNames.absolute]: absolute,
        },
        className,
      )}
      data-testid={testID}
      {...otherProps}
    >
      {children}
    </div>
  );
});

export type ViewRef = ComponentRef<typeof View>;
